import { useEffect } from 'react';

export const useClickOutside = (
    ref: React.RefObject<HTMLElement>,
    handler: (e: KeyboardEvent | MouseEvent | TouchEvent) => void,
    exceptionRef: React.RefObject<HTMLElement> | null = null,
) => {
    useEffect(() => {
        const listener = (event: KeyboardEvent | MouseEvent | TouchEvent) => {
            const el = ref?.current;
            const exceptionEl = exceptionRef?.current;

            const isElClicked = el?.contains(
                event.target instanceof Element ? event.target : null,
            );
            const isExceptionClicked = exceptionEl?.contains(
                event.target instanceof Element ? event.target : null,
            );
            const isKey = event.type === 'keydown';
            const isEscapeKey =
                isKey && 'key' in event && event.key === 'Escape';

            if (isEscapeKey) {
                handler(event);
            } else if (!el || isElClicked || isExceptionClicked || isKey) {
                // Do nothing if ref's element, its children, the (optional) exceptionRef's element or any key but ESC is clicked
                return;
            }

            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        document.addEventListener('keydown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
            document.removeEventListener('keydown', listener);
        };
    }, [ref, handler, exceptionRef]);
};
